import { render, staticRenderFns } from "./GroupContacts.vue?vue&type=template&id=d8e03640"
import script from "./GroupContacts.vue?vue&type=script&lang=js"
export * from "./GroupContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports